import { Navigate, createBrowserRouter } from 'react-router-dom'
import { authRoutes } from './pages/auth/routes'
import { dashboardRoutes } from 'pages/dashboard/routes'
import { accountRoutes } from 'pages/account/routes'
import { easyPayLayout } from 'pages/easyPay/routes'
import { fundRoutes } from 'pages/fund/routes'
import { loansRoutes } from 'pages/loans/routes'
import { walletRoutes } from 'pages/wallet/routes'
import { bankCards } from 'pages/bankAccounts/routes'
import { gatewayRoutes } from './pages/gatewayCallback/routes'
import { addBox } from 'pages/addMoneyPool/routes'
import { promissoryRoutes } from 'pages/promissory/routers'
import { AuthenticationUserRoutes } from 'pages/authenticationUsers/routers'
import { authNationalCode } from 'pages/auth_national_code/routes'
import { guaranteesRoutes } from 'pages/guarantees/routes'

export const routes = createBrowserRouter([
    { path: '/', element: <Navigate replace to="funds" /> },
    ...authRoutes,
    ...dashboardRoutes,
    ...accountRoutes,
    ...easyPayLayout,
    ...fundRoutes,
    ...loansRoutes,
    ...walletRoutes,
    ...bankCards,
    ...gatewayRoutes,
    ...addBox,
    ...promissoryRoutes,
    ...AuthenticationUserRoutes,
    ...authNationalCode,
    ...guaranteesRoutes,
])
